import { useNavigate, useParams } from 'react-router-dom';
import { Routes } from 'router/routes';
import React from 'react';

const PatientDetails: React.FC = () => {
  const navigate = useNavigate();
  const { patientGuid } = useParams();

  React.useEffect(() => {
    if (patientGuid) {
      navigate(Routes.patientGuid(`${patientGuid}`), { replace: true });
    }
  }, [navigate, patientGuid]);

  return null;
};

export default PatientDetails;
